import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const EdrPage = () => {
  const articles = [
    {
      slug: '/edr/defender-for-endpoint',
      tag: 'Tehdit Koruması',
      date: '6 Ekim 2025',
      readTime: '14 dk okuma',
      title: 'Gelişmiş Tehdit Koruması: Microsoft Defender for Endpoint Derinlemesine Rehber',
      description:
        'EDR çözümü ile uç nokta tehditlerini tespit edin, araştırın ve otomatik yanıt mekanizmalarını yapılandırın.',
      image:
        'https://public.readdy.ai/ai/img_res/3629c9ad1b443787a97e3ad0465a5130.jpg',
      icon: 'ri-bug-line',
      accent: 'from-[#0078D4] to-[#005A9E]',
      accentBg: 'bg-[#0078D4]',
    },
    {
      slug: '/edr/asr-kurallari',
      tag: 'Saldırı Yüzeyi',
      date: '17 Kasım 2025',
      readTime: '9 dk okuma',
      title: 'ASR Kuralları ile Saldırı Yüzeyi Azaltma Stratejileri',
      description:
        'Attack Surface Reduction kurallarını yapılandırarak organizasyonunuzu bilinen saldırı vektörlerine karşı proaktif olarak koruyun.',
      image:
        'https://readdy.ai/api/search-image?query=digital%20attack%20surface%20reduction%20concept%20with%20glowing%20red%20protective%20barriers%20and%20shrinking%20vulnerability%20zones%20around%20a%20corporate%20network%20visualization%20on%20dark%20background%20with%20abstract%20geometric%20defense%20layers%20and%20firewall%20icons&width=800&height=500&seq=edr-asr-rules-2&orientation=landscape',
      icon: 'ri-shield-cross-line',
      accent: 'from-[#005A9E] to-[#003D6B]',
      accentBg: 'bg-[#005A9E]',
    },
    {
      slug: '/edr/air-otomatik-yanit',
      tag: 'Otomatik Yanıt',
      date: '8 Aralık 2025',
      readTime: '10 dk okuma',
      title: 'Otomatik Soruşturma ve Yanıt (AIR) ile Hızlı Müdahale',
      description:
        'Automated Investigation and Response özelliklerini kullanarak güvenlik olaylarına hızlı ve etkili müdahale edin.',
      image:
        'https://readdy.ai/api/search-image?query=automated%20incident%20response%20system%20visualization%20with%20glowing%20red%20robotic%20arms%20analyzing%20security%20alerts%20and%20automated%20playbook%20workflows%20executing%20on%20a%20futuristic%20dark%20dashboard%20with%20flowing%20data%20streams%20and%20AI%20neural%20network%20patterns&width=800&height=500&seq=edr-air-response-3&orientation=landscape',
      icon: 'ri-flashlight-line',
      accent: 'from-[#0078D4] to-[#00BCF2]',
      accentBg: 'bg-[#0078D4]',
    },
    {
      slug: '/edr/tvm-guvenlik-acigi',
      tag: 'Güvenlik Açığı',
      date: '12 Ocak 2026',
      readTime: '12 dk okuma',
      title: 'Threat and Vulnerability Management ile Güvenlik Açığı Yönetimi',
      description:
        'TVM modülü ile organizasyonunuzdaki güvenlik açıklarını keşfedin, önceliklendirin ve düzeltme süreçlerini yönetin.',
      image:
        'https://readdy.ai/api/search-image?query=vulnerability%20management%20scanning%20interface%20with%20glowing%20red%20radar%20scanning%20corporate%20infrastructure%20revealing%20security%20gaps%20and%20risk%20scores%20with%20priority%20indicators%20on%20a%20dark%20modern%20technology%20background%20with%20abstract%20data%20visualization%20elements&width=800&height=500&seq=edr-tvm-vuln-4&orientation=landscape',
      icon: 'ri-scan-line',
      accent: 'from-[#00BCF2] to-[#0078D4]',
      accentBg: 'bg-[#00BCF2]',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#0078D4] to-[#005A9E] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
            }}
          />
        </div>
        <div className="relative max-w-6xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-lg mb-6">
              <span className="text-white text-sm font-medium">ENDPOINT DETECTION &amp; RESPONSE</span>
            </div>
            <h1 className="text-5xl font-bold text-white mb-6">Microsoft EDR</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Uç nokta tehdit algılama, otomatik soruşturma ve güvenlik açığı yönetimi hakkında derinlemesine teknik makaleler
            </p>
          </motion.div>
        </div>
      </section>

      {/* Makaleler */}
      <section className="py-24 bg-[#FAFBFC]">
        <div className="max-w-6xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-4">EDR Makaleleri</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Microsoft Defender for Endpoint hakkında derinlemesine teknik içerikler
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {articles.map((article, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15, duration: 0.5 }}
              >
                <Link
                  to={article.slug}
                  className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer border border-gray-100 hover:border-transparent"
                >
                  {/* Görsel Alanı */}
                  <div className="relative w-full h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                    {/* Üst Badge */}
                    <div className="absolute top-4 left-4 flex items-center space-x-2">
                      <span
                        className={`${article.accentBg} text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap flex items-center space-x-1.5 shadow-lg`}
                      >
                        <i className={`${article.icon} text-sm`}></i>
                        <span>{article.tag}</span>
                      </span>
                    </div>

                    {/* Alt Bilgi */}
                    <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <span className="text-white/80 text-xs flex items-center space-x-1">
                          <i className="ri-calendar-line text-sm"></i>
                          <span>{article.date}</span>
                        </span>
                        <span className="text-white/80 text-xs flex items-center space-x-1">
                          <i className="ri-time-line text-sm"></i>
                          <span>{article.readTime}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* İçerik Alanı */}
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-[#0078D4] transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-sm text-gray-500 leading-relaxed mb-5">{article.description}</p>

                    {/* Alt Kısım */}
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center space-x-2">
                        <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${article.accent} flex items-center justify-center`}>
                          <i className="ri-shield-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-xs text-gray-500 font-medium">EDR Rehberi</span>
                      </div>
                      <div className="flex items-center space-x-2 text-[#0078D4] text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <span className="whitespace-nowrap">Devamını Oku</span>
                        <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Diğer Konular */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Diğer Konulara Göz Atın</h2>
            <p className="text-lg text-gray-600 mb-8">
              Microsoft güvenlik çözümleri hakkında daha fazla içerik keşfedin
            </p>
            <div className="flex items-center justify-center space-x-4 flex-wrap gap-y-3">
              <Link
                to="/sentinel"
                className="px-8 py-3 bg-[#0078D4] hover:bg-[#006abc] text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Sentinel
              </Link>
              <Link
                to="/intune"
                className="px-8 py-3 bg-orange-600 hover:bg-orange-700 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Intune
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EdrPage;
